import { toBrazilianDate } from '../../../../helpers/utils/utils';
import { formatBRL } from '../../UI';

const CAMPOS_MONETARIOS = [
  'valorParcela', 'valorPrincipalCliente', 'valorMulta', 'valorProtesto',
  'valorJurosCliente', 'valorComissaoPagaCliente', 'valorNegociador',
  'valorDSR', 'valorComercial', 'valorPago',
];

/**
 * Colunas da grid "Lançamentos" (AW2-1078) — mesma lista/ordem das 17
 * colunas de `TableHeaderSintetica.jsx` (produção,
 * `src/pages/InspecionarProcesso/FichaFinanceira/Sintetica/`). Só `Data`
 * (`dataLancamento`) e `Acordo` (`acordo`) têm `ordenarPor` não-nulo — as
 * únicas 2 colunas com `OrdenacaoColuna` na tela real; as demais são
 * `null`, mesmo critério já usado em `titulosController.js`. `manual` nunca
 * passa por `formatarValorColunaLancamento` — é um indicador (ícone), não
 * um valor formatado, tratado à parte por `TableLancamentosSintetica.jsx`
 * (mesmo padrão da coluna `acoes` em `titulosController.js`/`TableTitulosProcesso.jsx`).
 */
export const COLUNAS_LANCAMENTOS = [
  {
    campo: 'manual', label: 'Manual', align: 'center', ordenarPor: null,
  },
  {
    campo: 'dataLancamento', label: 'Data', align: 'center', ordenarPor: 'dataLancamento',
  },
  {
    campo: 'acordo', label: 'Acordo', align: 'center', ordenarPor: 'acordo',
  },
  {
    campo: 'parcela', label: 'Parcela', align: 'center', ordenarPor: null,
  },
  {
    campo: 'valorParcela', label: 'Valor da Parcela', align: 'right', ordenarPor: null,
  },
  {
    campo: 'valorPrincipalCliente', label: 'Principal Cliente', align: 'right', ordenarPor: null,
  },
  {
    campo: 'valorMulta', label: 'Multa', align: 'right', ordenarPor: null,
  },
  {
    campo: 'valorProtesto', label: 'Protesto', align: 'right', ordenarPor: null,
  },
  {
    campo: 'valorJurosCliente', label: 'Juros Cliente', align: 'right', ordenarPor: null,
  },
  {
    campo: 'valorComissaoPagaCliente', label: 'Comissão paga pelo Cliente', align: 'right', ordenarPor: null,
  },
  {
    campo: 'hb', label: 'HB', align: 'right', ordenarPor: null,
  },
  {
    campo: 'valorNegociador', label: 'Valor Negociador', align: 'right', ordenarPor: null,
  },
  {
    campo: 'valorDSR', label: 'DSR', align: 'right', ordenarPor: null,
  },
  {
    campo: 'valorComercial', label: 'Valor Comercial', align: 'right', ordenarPor: null,
  },
  {
    campo: 'valorPago', label: 'Valor Pago', align: 'right', ordenarPor: null,
  },
  {
    campo: 'nomeNegociador', label: 'Nome Negociador', align: 'center', ordenarPor: null,
  },
  {
    campo: 'nomeComercial', label: 'Nome Comercial', align: 'center', ordenarPor: null,
  },
];

/**
 * Valor de exibição de uma célula do corpo, indexado pelo mesmo `campo` de
 * `COLUNAS_LANCAMENTOS` — header e corpo de `TableLancamentosSintetica.jsx`
 * iteram sobre o mesmo array de configuração (nunca uma lista de
 * `TableCell` hardcoded em paralelo), mesmo padrão já usado por
 * `formatarValorColuna`/`TableTitulosProcesso.jsx`.
 *
 * `hb` não é um campo direto do DTO — é a soma de `valorHonorarios` +
 * `valorJurosABE`, mesma fórmula de `TableBodySintetica.jsx` (produção,
 * linha 55: `getMoneyMask(ficha.valorHonorarios + ficha.valorJurosABE)`).
 *
 * Nunca chamada para `campo === 'manual'` — ver comentário de
 * `COLUNAS_LANCAMENTOS` acima.
 */
export function formatarValorColunaLancamento(campo, lancamento) {
  if (campo === 'dataLancamento') {
    return lancamento.dataLancamento == null ? '—' : toBrazilianDate(lancamento.dataLancamento);
  }

  if (campo === 'hb') {
    const { valorHonorarios, valorJurosABE } = lancamento;
    if (valorHonorarios == null && valorJurosABE == null) {
      return '—';
    }
    return formatBRL((valorHonorarios ?? 0) + (valorJurosABE ?? 0));
  }

  if (CAMPOS_MONETARIOS.includes(campo)) {
    return lancamento[campo] == null ? '—' : formatBRL(lancamento[campo]);
  }

  return lancamento[campo];
}
